import {
  USER_FETCH_REQUESTED,
  USER_RESOURCES_FETCH_REQUESTED,
  RESOURCE_EMBED_CONFIG_FETCH_REQUESTED,
  HIDE_LOADER,
  SHOW_LOADER,
} from './actionTypes'

export interface Action {
  type: string
  payload: any
}
export const getExtendedUser = (accessToken: string) => ({
  type: USER_FETCH_REQUESTED,
  payload: { accessToken },
})

export const getUserResources = (bearerToken: string) => ({
  type: USER_RESOURCES_FETCH_REQUESTED,
  payload: { bearerToken },
})

export const getResourceEmbedConfig = (
  resourceId: string,
  bearerToken: string
) => ({
  type: RESOURCE_EMBED_CONFIG_FETCH_REQUESTED,
  payload: {
    resourceId,
    bearerToken
  },
})

export const showLoader = () => ({
  type: SHOW_LOADER,
})

export const hideLoader = () => ({
  type: HIDE_LOADER,
})
